import PictureHtml from './picture-html';
import PlaceholderImageHtml from './placeholder-image-html';

export default class ProductCardSmallHtml {
    constructor(url, id, title, data, image, productCartButton) {
        this._url = url;
        this._id = id;
        this._title = title;
        this._data = data;
        this._image = image;
        this._productCartButton = productCartButton;
    }

    _getImageHtml() {
        const $globalConfig = config;

        if (this._image && this._image.identifier !== '') return new PictureHtml(this._image.WEBXS, this._image.WEBXS, this._image.WEBXS, this._image.alternateName, 'rfct-product-card-small__image').toString();
        return new PlaceholderImageHtml(16, 9, $globalConfig).toString();
    }

    _getContentHtml() {
        let tbody = '';

        this._data.forEach((e) => {
            tbody += `<tr><td>${e.name}</td><td>${e.value}</td></tr>`;
        });

        return `
            <span class="rfct-product-card-small__subline">${this._id}</span>
            <span class="rfct-product-card-small__headline">${decodeURIComponent(this._title)}</span>
    
            
            <div class="product-card__description">
                <table class="rfct-product-card-small__table">
                    <tbody>
                        ${tbody}
                    </tbody>
                </table>
            </div>
        `;
    }

    _getButtonHtml() {
        return `
            <div class="rfct-product-card-small__buttons">
                ${this._productCartButton}
            </div>
        `;
    }

    toString() {
        return `
            <div class="bar-carousel__slide">
                <a href="${this._url}" class="product-card rfct-product-card-small">
                    ${this._getImageHtml()}
                    <div class="product-card__inner">
                        ${this._getContentHtml()}
                        ${this._getButtonHtml()}
                    </div>
                </a>
            </div>
        `;
    }
}
